/**
 * DashboardFooter
 *
 * Thin bare-text link row. No icons, no card — pure connective text. Sits below
 * the triple-card row with `pt-6` breathing room.
 */

import { AMIR_CALL_URL } from "@/lib/constants/support"

export default function DashboardFooter() {
  return (
    <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground pt-6 pb-2">
      <a
        href="https://docs.humblytics.com"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground transition-colors"
      >
        Docs
      </a>
      <span className="text-muted-foreground/30">·</span>
      <a
        href="mailto:support@humblytics.com"
        className="hover:text-foreground transition-colors"
      >
        Support
      </a>
      <span className="text-muted-foreground/30">·</span>
      <a
        href={AMIR_CALL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:text-foreground transition-colors"
      >
        Book a call
      </a>
    </div>
  )
}
